module.exports = __webpack_public_path__ + "static/media/img10.b187b796.png";